module.exports = __webpack_public_path__ + "static/media/email_icon_black.6d249a61.png";